<template>
    <div class="summary-block">
        <ul>
            <li v-for="(daySummary, index) in summaryData" :key="index">
                <strong>
                    <span class="weekday">{{ getWeekday(daySummary.day) }}</span>,
                    <span class="date-highlight">{{ getDate(daySummary.day) }}</span>
                </strong>:
                <span class="total-time">{{ daySummary.total_time }}</span>
                <ul>
                    <li
                        v-for="(work, workIndex) in daySummary.works"
                        :key="workIndex"
                        :class="{ clickable: isEditableWeek(daySummary.week) }"
                        @click="askForWorkRemoval(work, daySummary.week)"
                    >
                        <span class="work-time">{{ work.start }} - {{ work.end }}</span>
                        <span class="project-title">{{ work.project_title }}</span>
                        <span v-if="isEditableWeek(daySummary.week)" class="remove-icon">⨯</span>
                    </li>
                </ul>
            </li>
        </ul>
        <confirm-modal
            modal-id="deleteWorkModal"
            title="Delete Work Entry"
            message="Are you sure you want to delete this work entry?"
            @confirm="confirmDelete"
            @cancel="cancelWorkRemoval"
        />
    </div>
</template>

<script>
import axios from "axios";
import ConfirmModal from "../Basic/ConfirmModal.vue";

export default {
    name: 'SummaryBlock',
    components: { ConfirmModal },
    props: {
        summaryData: {
            type: Array,
            required: true
        },
        isEditableWeek: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            workToDelete: null,
            weekToDeleteFrom: null,
        };
    },
    methods: {
        getWeekday(dayString) {
            return dayString.split(",")[0];
        },
        getDate(dayString) {
            return dayString.split(",")[1].trim();
        },
        askForWorkRemoval(work, week) {
            if (!this.isEditableWeek(week)) {
                return false;
            }

            this.workToDelete = work;
            this.weekToDeleteFrom = week;

            $('#deleteWorkModal').modal('show');
        },
        confirmDelete() {
            if (!this.workToDelete) {
                console.error("No work entry selected for deletion.");
                return;
            }

            axios
                .delete(`/api/entries/${this.workToDelete.id}`)
                .then(() => {
                    this.$emit('work-removed');
                })
                .catch(error => {
                    console.error("Failed to delete work entry:", error);
                    alert("Failed to delete the entry. Please try again.");
                })
                .finally(() => {
                    this.resetWorkRemoval();
                });
        },
        cancelWorkRemoval() {
            this.resetWorkRemoval();
        },
        resetWorkRemoval() {
            this.workToDelete = null;
            this.weekToDeleteFrom = null;
        }
    }
};
</script>

<style scoped>
.summary-block {
    min-height: 200px;
    border-top: 1px solid #8a8e8a;

    ul {
        margin-left: 15px;
        margin-top: 15px;

        li {
            display: block;
            margin-bottom: 25px;

            &.clickable {
                cursor: pointer;

                &:hover {
                    background-color: #f0f4f8;
                }
            }

            ul {
                li {
                    display: flex;
                    align-items: center;
                    flex-wrap: nowrap;
                    border-bottom: 1px solid lightgray;
                    margin-bottom: 5px;

                    .work-time {
                        flex: 0 0 100px;
                        margin-right: 10px;
                    }

                    .project-title {
                        flex: 1 1 auto;
                        font-weight: bold;
                        overflow-wrap: break-word;
                        word-break: break-word;
                        margin-right: 10px;
                        white-space: normal;
                    }

                    .remove-icon {
                        flex: 0 0 auto;
                        margin-left: auto;
                        color: #d9534f;
                        font-weight: bold;
                        cursor: pointer;
                        margin-right: 15px;

                        &:hover {
                            color: #c9302c;
                        }
                    }
                }
            }
        }
    }

    li {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    div {
        margin: 5px 0;
        font-weight: bold;
        color: #888;
    }
}

.clickable {
    cursor: pointer;
}

.remove-icon {
    color: red;
    margin-left: 10px;
    cursor: pointer;
}

.date-highlight {
    color: #124e86;
}

.weekday {
    color: #000;
}
</style>
